module.exports = __webpack_public_path__ + "static/img/tab3-active.a1a6a16e.png";